import BarsIcon from "../images/bars.png";
import TickIcon from "../images/tick-icon2.png";
import TimeIcon from "../images/time-icon.png";
import GiftIcon from "../images/gift-icon.png";
import Doctor1 from "../images/Doctor-1.png";
import Doctor2 from "../images/Doctor-2.png";
import Doctor3 from "../images/Doctor-3.png";
import Doctor4 from "../images/Doctor-4.png";
import Doctor5 from "../images/Doctor-5.png";
import BlueTick from "../images/blue-tick.svg";
import OrangeTick from "../images/orange-tick.svg";
import PurpleTick from "../images/purple-tick.svg";
import GreenTick from "../images/green-tick.svg";
import ProfileAvatar from "../images/profile-avatar.png";
import ProfileAvatarWomen from "../images/profile-avatar-women.png";

export const cardDetails = [
  {
    img: BarsIcon,
    imgBgColor: "#EBDCFF",
    bgColor: "#F4EBFF",
    title: "Personalized Matches",
    label: "Personalized Matches",
    detail:
      "Our SmartMatch™ Algorithm takes into account your specific requirements to connect you with healthcare professionals tailored to your needs.",
  },
  {
    img: TickIcon,
    imgBgColor: "#D2ECFF",
    bgColor: "#EBF7FF",
    title: "Trusted Experts",
    label: "Trusted Experts",
    detail:
      "We rigorously vet each health professional to ensure they possess the necessary qualifications, experience, and positive reviews.",
  },
  {
    img: TimeIcon,
    imgBgColor: "#FFE2CF",
    bgColor: "#FFF3EB",
    title: "Save Time",
    label: "Save Time",
    detail:
      "Avoid hours of research, frustration and doubt by letting HelpMatch quickly find the ideal healthcare specialist for you.",
  },
  {
    img: GiftIcon,
    imgBgColor: "#C2FFE5",
    bgColor: "#E8FFF5",
    title: "Free to Use",
    label: "Free to Use",
    detail:
      "Get matched to your perfect health professional without paying a penny. Our matching service is 100% free.",
  },
];

export const cardDetailsHomePage = [
  {
    img: BarsIcon,
    imgBgColor: "#EBDCFF",
    bgColor: "rgba(125, 52, 216, 0.03)",
    borderColor: "#EBDCFF",
    title: "Fast and Easy Matching",
    label: "Fast and Easy Matching",
    detail:
      "Our SmartMatch™ Technology connects you with a top-rated local providers who can meet your unique care needs now.",
  },
  {
    img: TickIcon,
    imgBgColor: "#D2ECFF",
    bgColor: "rgba(29, 144, 254, 0.03)",
    borderColor: "#D2ECFF",
    title: "Trusted Experts",
    label: "Trusted Experts",
    detail:
      "We ensure the provider we match you with is qualified, experienced, and top-rated as reviewed by their own patients.",
  },
  {
    img: TimeIcon,
    imgBgColor: "#FFE2CF",
    bgColor: "rgba(238, 109, 36, 0.03)",
    borderColor: "#FFE2CF",
    title: "Save Your Time",
    label: "Save Your Time",
    detail:
      "Skip the hassle of searching, research and frustration, and let HelpMatch quickly connect you with a top-rated provider.",
  },
  {
    img: GiftIcon,
    imgBgColor: "#DEF9E4",
    bgColor: "rgba(22, 202, 124, 0.03)",
    borderColor: "#C4ECCD",
    title: "Free to Use",
    label: "Free to Use",
    detail:
      "No wallet needed! Our service is 100% free to get matched with a great provider who can get you in their office fast.",
  },
];

export const dentistCardDetails = [
  {
    img: BarsIcon,
    imgBgColor: "#EBDCFF",
    bgColor: "#F4EBFF",
    title: "Personalized Matches",
    detail:
      "Our SmartMatch™ Technology connects you with a top-rated local dentist who meets your unique care needs.",
  },
  {
    img: TickIcon,
    imgBgColor: "#D2ECFF",
    bgColor: "#EBF7FF",
    title: "Trusted Professionals",
    detail:
      "We ensure the dentist you match with is top-rated and qualified for great patient care outcomes.",
  },
  {
    img: TimeIcon,
    imgBgColor: "#FFE2CF",
    bgColor: "#FFF3EB",
    title: "Save Your Time",
    detail:
      "Skip the hassle of searching, research and frustration, and let HelpMatch quickly connect you with a top-rated local dentist.",
  },
  {
    img: GiftIcon,
    imgBgColor: "#C2FFE5",
    bgColor: "#E8FFF5",
    title: "Free to Use",
    detail:
      "No wallet needed! Our service is 100% free to get matched with a great local dentist who can help, no strings attached.",
  },
];

export const orthopedicServicesCardDetails = [
  {
    img: BarsIcon,
    imgBgColor: "#EBDCFF",
    bgColor: "#F4EBFF",
    title: "Personalized Matches",
    detail:
      "Our SmartMatch™ Technology connects you with a top-rated joint-pain doctor who meets your unique care needs.",
  },
  {
    img: TickIcon,
    imgBgColor: "#D2ECFF",
    bgColor: "#EBF7FF",
    title: "Trusted Experts",
    detail:
      "We ensure the joint pain and mobility doctor you match with is top-rated and qualified for great patient care outcomes.",
  },
  {
    img: TimeIcon,
    imgBgColor: "#FFE2CF",
    bgColor: "#FFF3EB",
    title: "Save Your Time",
    detail:
      "Skip the hassle of searching and research, and let HelpMatch quickly connect you with a top-rated local joint pain doctor.",
  },
  {
    img: GiftIcon,
    imgBgColor: "#C2FFE5",
    bgColor: "#E8FFF5",
    title: "Free to Use",
    detail:
      "No wallet needed! Our service is 100% free to get matched with a great joint pain doctor who can help, no strings attached.",
  },
];

export const helpMatchWork = [
  "Tell Us What Health Related Service You Need and Where You Need It",
  "Answer a Few Additional Quick and Easy Questions to Ensure the Perfect Match",
  "Get Matched to a Qualified and Trusted Health Professional Who Can Help You",
];

export const helpMatchHomePageWork = [
  {
    title: "Tell Us Your Provider Needs",
    label: "Need a Dentist? Therapist? OBGYN? Chiropractor? We’ve Got You 😊",
  },
  {
    title: "Select the Services You Need",
    label: "Tell Us What Medical Services You Need for Accurate Matching",
  },
  {
    title: "Get Matched & Connect!",
    label: "We’ll Connect You with Your Match So You Can Book an Appointment!",
  },
];

export const helpMatchDentistWork = [
  {
    title: "Tell Us Your Needs",
    label:
      "Tell Us Where You Need a Dentist and the Services You’re Looking For",
  },
  {
    title: "Answer a Few Quick Questions",
    label: "This Helps Us Ensure the Perfect Match for You",
  },
  {
    title: "Get Matched!",
    label: "Get Matched to a Qualified and Trusted Dentist Who Can Help You",
  },
];

export const helpMatchOrthopedicServicesWork = [
  {
    title: "Tell Us Your Needs",
    label:
      "Tell us Your Location and Services You Might Need for a Joint Pain Doctor",
  },
  {
    title: "Answer a Few Quick Questions",
    label: "This Helps Us Ensure the Perfect Match for You",
  },
  {
    title: "Get Matched!",
    label:
      "Get Matched to a Qualified and Trusted Joint Pain Doctor Who Can Help You",
  },
];

export const categoryTabs = [
  {
    id: 1,
    tabTitle: "Physicians/Doctors",
    imgDes: "Title 1",
    content: [
      {
        title: "Primary Care Physicians",
        imgUrl: Doctor1,
      },
      {
        title: "Pediatricians",
        imgUrl: Doctor2,
      },
      {
        title: "Family Doctors",
        imgUrl: Doctor3,
      },
      {
        title: "Gynecologists (OB/GYNs)",
        imgUrl: Doctor4,
      },
      {
        title: "Internal Medicine Doctors",
        imgUrl: Doctor5,
      },
      {
        title: "Geriatricians (Sr. Care)",
        imgUrl: Doctor2,
      },
    ],
  },
  {
    id: 2,
    tabTitle: "Mental Health Professionals",
    imgDes: "Title 2",
    content: [
      {
        title: "Pediatricians",
        imgUrl: Doctor2,
      },
      {
        title: "Primary Care Physicians",
        imgUrl: Doctor1,
      },
      {
        title: "Family Doctors",
        imgUrl: Doctor3,
      },
      {
        title: "Internal Medicine Doctors",
        imgUrl: Doctor5,
      },
      {
        title: "Gynecologists (OB/GYNs)",
        imgUrl: Doctor4,
      },
      {
        title: "Geriatricians (Sr. Care)",
        imgUrl: Doctor2,
      },
    ],
  },
  {
    id: 3,
    tabTitle: "Chiropactors",
    imgDes: "Title 3",
    content: [
      {
        title: "Gynecologists (OB/GYNs)",
        imgUrl: Doctor4,
      },
      {
        title: "Pediatricians",
        imgUrl: Doctor2,
      },
      {
        title: "Family Doctors",
        imgUrl: Doctor3,
      },
      {
        title: "Primary Care Physicians",
        imgUrl: Doctor1,
      },
      {
        title: "Internal Medicine Doctors",
        imgUrl: Doctor5,
      },
      {
        title: "Geriatricians (Sr. Care)",
        imgUrl: Doctor2,
      },
    ],
  },
  {
    id: 4,
    tabTitle: "Dentists",
    imgDes: "Title 4",
    content: [
      {
        title: "Primary Care Physicians",
        imgUrl: Doctor1,
      },
      {
        title: "Pediatricians",
        imgUrl: Doctor2,
      },
      {
        title: "Internal Medicine Doctors",
        imgUrl: Doctor5,
      },
      {
        title: "Gynecologists (OB/GYNs)",
        imgUrl: Doctor4,
      },
      {
        title: "Family Doctors",
        imgUrl: Doctor3,
      },
      {
        title: "Geriatricians (Sr. Care)",
        imgUrl: Doctor2,
      },
    ],
  },
  {
    id: 5,
    tabTitle: "Physical Therapists",
    imgDes: "Title 5",
    content: [
      {
        title: "Internal Medicine Doctors",
        imgUrl: Doctor5,
      },
      {
        title: "Family Doctors",
        imgUrl: Doctor3,
      },
      {
        title: "Gynecologists (OB/GYNs)",
        imgUrl: Doctor4,
      },
      {
        title: "Pediatricians",
        imgUrl: Doctor2,
      },
      {
        title: "Primary Care Physicians",
        imgUrl: Doctor1,
      },
      {
        title: "Geriatricians (Sr. Care)",
        imgUrl: Doctor2,
      },
    ],
  },
];

export const helpMatchItems = [
  {
    img: PurpleTick,
    bgColor: "#F4EBFF",
    detail:
      "<b>Save Time and Skip the Search:</b> Leave the hard work of finding a great provider to us.",
  },
  {
    img: BlueTick,
    bgColor: "#EBF7FF",
    detail:
      "<b>No Cost to You:</b> Our service is free to find top-rated healthcare without the hassle.",
  },
  {
    img: OrangeTick,
    bgColor: "#FFF3EB",
    detail:
      "<b>Instant Connections with Verified Pros:</b> Connect with qualified providers you can trust, right away.",
  },
  {
    img: GreenTick,
    bgColor: "#E8FFF5",
    detail:
      "<b>Flexible Payment Options:</b> Get matched with top-rated providers for either insurance or cash-pay.",
  },
];

export const aboutUsItems = [
  {
    img: PurpleTick,
    bgColor: "#F4EBFF",
    
    detail:
      "<b>Find the Right Fit Faster:</b>  No more trial and error, get matched with a provider who actually meets your needs.",
  },
  {
    img: BlueTick,
    bgColor: "#EBF7FF",
    detail:
      "<b>Book Sooner, Not Later:</b> See real-time availability with providers who are ready to help now.",
  },
  // {
  //   img: OrangeTick,
  //   bgColor: "#FFF3EB",
  //   detail:
  //     "<b>Instant Connections with Verified Pros:</b> Connect with qualified providers you can trust, right away.",
  // },
  {
    img: GreenTick,
    bgColor: "#E8FFF5",
    
    detail:
      "<b>Feel Cared For Every Step: </b> From your first click to your first visit, the process feels easy and human.",
  },
];

export const faqs = [
  {
    question: "What is HelpMatch and how does it work?",
    answer:
      "HelpMatch is a platform that connects individuals with verified healthcare providers using our SmartMatch™ AI technology. Simply provide your healthcare needs and location, and we will match you with a qualified provider that fits your unique needs and preferences.",
  },
  {
    question: "Does HelpMatch cost me money?",
    answer:
      "Connecting with a verified healthcare provider through HelpMatch is completely free of charge.",
  },
  {
    question:
      "How long does it take to get matched with a healthcare provider?",
    answer:
      "Matching with a healthcare provider through HelpMatch typically takes just a few minutes. Our SmartMatch™ technology quickly connects you with the most suitable provider based on your unique needs and preferences.",
  },
  {
    question:
      "How do I know the healthcare providers are legit and actually provide good service?",
    answer:
      "All healthcare professionals on HelpMatch have passed a thorough onboarding and qualification screening process to confirm they are fully licensed and have good reviews from existing and past patients.",
  },
  {
    question:
      "Can HelpMatch find healthcare providers that accept my insurance?",
    answer:
      "Yes, during the matching process, we'll ask about your insurance if you have it, and you'll only be matched with providers who accept your insurance.",
  },
  {
    question: "How do I contact the healthcare provider once I’m matched?",
    answer:
      "Once matched, you'll be able to text message and/or call the healthcare provider or their office. If they provide virtual healthcare services, you can meet with them using HelpMatch Virtual, our own private and secure peer-to-peer video platform.",
  },
  {
    question:
      "How do I know if a healthcare provider is accepting new patients?",
    answer:
      "HelpMatch ensures that you are matched only with healthcare providers who are currently accepting new patients. Our system continuously updates provider availability to offer you the best options.",
  },
  {
    question: "Can I use HelpMatch for urgent healthcare needs?",
    answer:
      "While HelpMatch can help you find providers quickly, it is not designed for emergency situations. For emergencies, please call 911 or go to the nearest emergency room. If you are feeling suicidal, you can reach the National Suicide Prevention Lifeline by dialing or texting the number 988.",
  },
];

export const virtualFaq = [
{
  question:"What is virtual therapy?",
  answer:"Virtual therapy is a convenient, effective way to receive mental health support through secure video sessions with licensed therapists from the comfort of your home."
},
{
  question:"How can HelpMatch connect me with a virtual therapist?",
  answer:"HelpMatch instantly pairs you with a licensed therapist based on your unique needs and preferences, ensuring a personalized fit for your therapy goals."
},
{
  question:"Is virtual therapy covered by insurance?",
  answer:"Many insurance plans cover virtual therapy sessions. We connect you with therapists who either accept your insurance or offer affordable self-pay options to fit your budget."
},
{
  question:"How soon can I start virtual therapy after matching?",
  answer:"You can typically book your first virtual session within days of matching, getting you started on your mental health journey quickly and easily."
},
{
  question:"What conditions can virtual therapy treat effectively?",
  answer:"Virtual therapy effectively addresses a wide range of issues, including anxiety, depression, stress, relationship challenges, grief, and more.",
},
{
  question:"Is virtual therapy safe?",
  answer:"Yes, when conducted by licensed professionals on secure platforms, virtual therapy is safe, private, and confidential, giving you peace of mind during every session."
},
{
question:"How many virtual therapy sessions will I need?",
answer:"The number of sessions varies depending on your goals, and your ongoing therapeutic progress. Your matched therapist can better walk you through a better expectation based on your unique situation."
},
{
  question:"How are virtual therapy sessions conducted?",
  answer:"Sessions take place securely online via secure video meeting, designed to fit your schedule and comfort level - no travel required."
},
{
  question:"Is there any preparation needed before starting virtual therapy?",
  answer:"Your therapist will provide simple instructions to ensure a smooth start, like finding a quiet space and testing your internet connection, so you feel ready and supported."
},
{
question:"How do I get started with HelpMatch?",
answer:"Simply enter your zip code and complete our quick questionnaire to match instantly with a licensed, top-rated virtual therapist who can help now."
}
]


export const virtualPsychiatricFaq = [
  {
    question:"What is HelpMatch?",
    answer:"HelpMatch is a free matching service that connects you with trusted, fully licensed virtual psychiatry providers based on your needs and preferences."
  },
  {
    question:"How does the matching process work?",
    answer:"Just enter your ZIP code and answer a few quick questions. We’ll instantly match you with the best virtual psychiatry providers available for you."
  },
  {
    question:"How does HelpMatch ensure the quality of healthcare professionals?",
    answer:"Every provider in our network is fully licensed, thoroughly vetted, and carefully reviewed for experience, patient feedback, and professional qualifications. We only work with providers committed to delivering excellent virtual care."
  },
  {
    question:"Is there any cost to use HelpMatch?",
    answer:"No, getting matched is completely free. You only pay if you choose to engage in services with your matched provider. Many providers accept insurance, or offer affordable self-pay options."
  },
  {
    question:"How soon can I get an appointment?",
    answer:"Many people are able to book a virtual visit within 24–72 hours, often much sooner.",
  },
  {
    question:"Is my information private and secure?",
    answer:"Absolutely, your privacy is important to us. HelpMatch is HIPAA-compliant and your information is always kept secure. You can learn more about how we handle sensitive information by reading our Privacy Policy (link --> open new tab)."
  },
  {
  question:"How do I contact a healthcare professional once I’m matched?",
  answer:"Once you’re matched, you’ll receive the provider’s contact details and next steps to book your appointment directly. Most providers offer secure online scheduling or a private call to get started right away."
  },
  // {
  //   question:"How do I get started with HelpMatch?",
  //   answer:"Sessions take place securely online via secure video meeting, designed to fit your schedule and comfort level - no travel required."
  // },
  // {
  //   question:"Is there any preparation needed before starting virtual therapy?",
  //   answer:"Your therapist will provide simple instructions to ensure a smooth start, like finding a quiet space and testing your internet connection, so you feel ready and supported."
  // },
  // {
  // question:"How do I get started with HelpMatch?",
  // answer:"Simply enter your zip code and complete our quick questionnaire to match instantly with a licensed, top-rated virtual therapist who can help now."
  // }
  ]
export const ketaMineFaq = [
  {
    question: "What is Ketamine Therapy?",
    answer:"Ketamine therapy is an innovative treatment involving supervised administration of ketamine to rapidly relieve symptoms of depression, anxiety, PTSD, chronic pain, and more.",
  },
  {
    question: "How can HelpMatch connect me with a Ketamine therapist?",
    answer: "HelpMatch quickly pairs you with a licensed Ketamine therapist based on your specific therapy goals and location.",
  },

  {
    question: "Is Ketamine therapy covered by insurance?",
    answer: "Many insurance providers cover Ketamine therapy, but coverage may vary due to the dynamic nature of insurance plans. Your matched therapist can help guide you through this process.",
  },
  {
    question: "How soon can I start Ketamine therapy after matching?",
    answer: "You can typically schedule your initial consultation within days of matching..",
  },
  {
    question: "What conditions can Ketamine therapy treat effectively?",
    answer: "Ketamine therapy helps treat depression, anxiety, PTSD, trauma, chronic pain, OCD, addiction, and more.",
  },
  {
    question: "Is Ketamine therapy safe?",
    answer: "Yes, when administered by qualified, licensed therapists, Ketamine therapy is considered safe and effective.",
  },
  {
    question: "How many sessions of Ketamine therapy will I need?",
    answer:"The number of sessions varies by individual, but most people start seeing improvement within 3-6 sessions.",
  },
  {
    question:"How are Ketamine therapy sessions conducted?",
    answer:"Sessions are conducted securely, privately, and typically virtually or in a therapist’s comfortable office setting.",
  },
  {
    question: "Is there any preparation needed before starting Ketamine therapy?",
    answer:"Your therapist will provide guidelines to ensure you're prepared and comfortable for your therapy sessions.",
  },
  {
    question:"How do I get started with HelpMatch?",
    answer:"Simply enter your zip code and complete our quick questionnaire to match instantly with your Ketamine therapy specialist."
  }
];

export const supportFaqs = [
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
  {
    question: "When is the last day for pre-order?",
    answer:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.",
  },
];

export const onBoardingFlowData = [
  {
    question: "Which service(s) are you looking for?",
    questionDetail: "",
    answertype: "checkbox",
    answers: [
      {
        num: 1,
        optionDetail: "",
        option: "Regular Checkup",
        answerInputType: "",
      },
      {
        num: 2,
        optionDetail: "",
        option: "Cleaning / Hygenist Services",
        answerInputType: "",
      },
      {
        num: 3,
        optionDetail:
          "Cavity removal and filling services are dental procedures to treat tooth decay. The dentist removes the decayed portion of the tooth, cleans the affected area, and fills the cavity with a dental filling material to restore the tooth's function and prevent further decay",
        option: "Cavity Removal / Filling",
        answerInputType: "",
      },
      {
        num: 4,
        optionDetail: "",
        option: "Aleviate Tooth Pain",
        answerInputType: "",
      },
      {
        num: 5,
        optionDetail: "",
        option: "Orthodontist / Braces",
        answerInputType: "",
      },
      {
        num: 6,
        optionDetail: "",
        option: "Teeth Whitening",
        answerInputType: "",
      },
      {
        num: 7,
        optionDetail: "",
        option: "Dental Surgery",
        answerInputType: "",
      },
      {
        num: 8,
        optionDetail: "",
        option: "Pediatric Dental Services",
        answerInputType: "",
      },
    ],
  },
  {
    question: "How many teeth are affected?",
    questionDetail: "",
    answertype: "checkbox",
    answers: [
      {
        num: 1,
        optionDetail: "",
        option: "Just 1 tooth",
        answerInputType: "",
      },
      {
        num: 2,
        optionDetail: "",
        option: "Multiple teeth",
        answerInputType: "",
      },
      {
        num: 3,
        optionDetail: "",
        option: "My entire mouth",
        answerInputType: "",
      },
    ],
  },
  {
    question: "When did you last visit a dentist?",
    questionDetail: "",
    answertype: "checkbox",
    answers: [
      {
        num: 1,
        optionDetail: "",
        option: "Within the last year",
        answerInputType: "",
      },
      {
        num: 2,
        optionDetail: "",
        option: "More than a year ago",
        answerInputType: "",
      },
    ],
  },
  {
    question: "Do you currently have insurance?",
    questionDetail: "",
    answertype: "checkbox",
    answers: [
      {
        num: 1,
        optionDetail: "",
        option: "Yes",
        answerInputType: "",
      },
      {
        num: 2,
        optionDetail: "",
        option: "No",
        answerInputType: "",
      },
      {
        num: 3,
        optionDetail: "",
        option: "Not Sure",
        answerInputType: "",
      },
      {
        num: 4,
        optionDetail: "",
        option: "I'd rather not say",
        answerInputType: "",
      },
    ],
  },
  {
    question: "What is your email address?",
    questionDetail: "We'll send you your matches for easy reference.",
    answertype: "inputEmail",
    answers: [
      {
        num: 1,
        optionDetail: "",
        option: "",
        answerInputType: "email",
      },
    ],
  },
  {
    question: "What is your name and phone number?",
    questionDetail: "",
    answertype: "inputDetail",
    answers: [
      {
        num: 1,
        optionDetail: "",
        option: "",
        answerInputType: "",
      },
    ],
  },
  {
    question: "How soon would you like an appointment?",
    questionDetail: "",
    answertype: "checkbox",
    answers: [
      {
        num: 1,
        optionDetail: "",
        option: "Immediately",
        answerInputType: "",
      },
      {
        num: 2,
        optionDetail: "",
        option: "Within the next few days",
        answerInputType: "",
      },
      {
        num: 3,
        optionDetail: "",
        option: "In the next week",
        answerInputType: "",
      },
      {
        num: 4,
        optionDetail: "",
        option: "In the next month",
        answerInputType: "",
      },
      {
        num: 5,
        optionDetail: "",
        option: "1-2 months",
        answerInputType: "",
      },
      {
        num: 6,
        optionDetail: "",
        option: "Other",
        answerInputType: "",
      },
    ],
  },
];

export const homeHelpMatchItems = [
  {
    img: GreenTick,
    altImg: "Green Tick",
    bgColor: "#E8FFF5",
    label: "Say Goodbye to the Search Time-Suck:",
    detail:
      "No more exhaustive searching and sifting through reviews, feeling overwhelmed and uncertain of your options.",
  },
  {
    img: OrangeTick,
    altImg: "Orange Tick",
    bgColor: "#FFF3EB",
    label: "SmartMatch™ A.I. Technology:",
    detail:
      "Get intelligently paired with a healthcare provider in your area who meets your unique needs and accepts your insurance.",
  },
  {
    img: BlueTick,
    altImg: "Blue Tick",
    bgColor: "#EBF7FF",
    label: "Personalized Care:",
    detail:
      "Feel confident knowing you're connected to a high-rated healthcare provider that truly understands you and your unique healthcare needs.",
  },
];

export const homePageHelpMatchItems = [
  {
    img: GreenTick,
    altImg: "Green Tick",
    bgColor: "#E8FFF5",
    label: "Find a Provider Whose Patients Love Them",
    detail:
      "With HelpMatch, you’ll connect with professionals who are trusted and loved by their patients, and known for delivering exceptional care and positive experiences.",
  },
  {
    img: OrangeTick,
    altImg: "Orange Tick",
    bgColor: "#FFF3EB",
    label: "We Only Recommend Providers We’d Choose for Ourselves:",
    detail:
      "We hold providers to the highest standards, only recommending those we’d trust for ourselves and our own loved ones.",
  },
  {
    img: BlueTick,
    altImg: "Blue Tick",
    bgColor: "#EBF7FF",
    label: "What Matters Most to You Also Matters Most to Us:",
    detail:
      "Top-rated, caring, and skilled - your priorities are ours too. Let us help you find a great provider by tapping on ‘Get Matched Now’.",
  },
];

export const homeHelpMatchDentistItems = [
  {
    img: GreenTick,
    bgColor: "#E8FFF5",
    label: "Ditch the Google Searching and Get Help Now:",
    detail:
      "We eliminate the stress of searching for a great dentist so you can save time and get in the office fast!",
  },
  {
    img: OrangeTick,
    bgColor: "#FFF3EB",
    label: "SmartMatch™ - Your Personal Matchmaker:",
    detail:
      "Our technology finds your ideal dentist match based on your unique needs and preferences.",
  },
  {
    img: BlueTick,
    bgColor: "#EBF7FF",
    label: "Smile Confidently with Tailored Care:",
    detail:
      "You'll be matched with a dentist who will provide great care, tailored to your unique healthcare needs. ",
  },
];

export const messagesData = [
  {
    id: 1,
    icon: ProfileAvatarWomen,
    title: "Jane Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 2,
    icon: ProfileAvatar,
    title: "John Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 3,
    icon: ProfileAvatarWomen,
    title: "Jane Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 4,
    icon: ProfileAvatar,
    title: "John Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 5,
    icon: ProfileAvatarWomen,
    title: "Jane Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 6,
    icon: ProfileAvatar,
    title: "John Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 7,
    icon: ProfileAvatarWomen,
    title: "Jane Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 8,
    icon: ProfileAvatar,
    title: "John Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
  {
    id: 9,
    icon: ProfileAvatarWomen,
    title: "Jane Doe",
    label: "Hi, I'd like to schedule an appointment...",
    time: "05:11",
  },
];
